export default function MySQL_COALESCE() {
  return (
    <div>
      <h2>MySQL_COALESCE</h2>    </div>
  );
}